import React from "react";
import { Link } from "react-router-dom";


export default function Join() {
  return (
    <div className="container py-5 text-end" style={{marginTop:50, marginBottom:50}}>
      <h1 className="fw-bold text-success mb-5">
          بە یەکێک لە خێزانی یاسا
      </h1>
      <p className="mb-4">
        .پارێزەری زێدە خۆشەویست لە دوای پڕکردنەوەی ئەم فۆڕمە دەبێتە یەکەک لە خێزانی ئەپی یاسا
      </p>
      <p className="mb-4">
        .تکایە لە فۆڕمەکە تەواوی زانیاریەکانت بە درووستی پڕ بکەوە و دووجار دڵنیا ببەوە لەوەی زانیاریەکانت درووستن

      </p>
      <p className="mb-3">
        ...لەگەڵ ڕێزی بێ پایانماندا
      </p>

    <div className="d-flex justify-content-end">
  <Link
    to="/form"
    className="btn btn-success d-flex align-items-center justify-content-center fs-4"
    style={{ width: 180 , height:60, marginRight:50, marginTop:85 }}
  >
    تۆمارکردن
  </Link>
</div>
    </div>
  );
}